export const appSwitcherDefaults = {
    click: "klik",
    newTab: "Openen in nieuw tabblad",
};
export default appSwitcherDefaults;
